import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function IndoorGames(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M14.787 2.542C10.315 1.2 4.517 3.718 2.205 11.296c-.66 2.163.5 4.285 2.333 5.277l-1.378 2.48a2 2 0 00.946 2.804l2.18.954a2 2 0 002.526-.819l1.548-2.632.284.135c1.784.851 4.147.644 5.449-1.169 2.008-2.797 2.98-6.248 2.854-9.217-.124-2.925-1.364-5.728-4.16-6.567zM8.55 18.495l-2.206-1.053-1.435 2.582 2.18.954 1.46-2.483zM4.118 11.88c2.055-6.736 6.876-8.388 10.095-7.422 1.597.479 2.627 2.179 2.736 4.736.106 2.513-.729 5.525-2.48 7.966-.595.828-1.813 1.079-2.963.53l-5.882-2.807c-1.234-.589-1.853-1.866-1.506-3.003zM19.5 20.5a1 1 0 100-2 1 1 0 000 2zm0 1.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z",
    clipRule: "evenodd"
  }));
}

export default IndoorGames;